<p-confirmDialog />
@if (isLoadingData) {
    <div class="flex justify-center">
        <p-progress-spinner ariaLabel="loading" />
    </div>
}
@else {
  <div cdkDropList cdkDropListOrientation="mixed" (cdkDropListDropped)="onDrop($event)" class="grid grid-cols-12 gap-4">
    @for (photo of photos; track photo; let idx = $index) {
      <div class="col-span-4" cdkDrag cdkDragBoundary=".p-tabpanel" [cdkDragDisabled]="isSendingData">
        <div class="col-span-4 rounded-md bg-surface-100 dark:bg-surface-800" *cdkDragPlaceholder></div>
        <div class="card !p-0 relative">
          <img (click)="showViewer($event)" [src]="apiUrl + photo.thumbnail_url" alt="placeholder" class="block rounded-md aspect-square object-cover w-full cursor-zoom-in">
          <div class="absolute top-2 left-2 right-2 flex justify-between">
            <p-tag cdkDragHandle icon="pi pi-arrows-alt" severity="contrast" [value]="(photo.ordre != null ? photo.ordre + 1 : photo.ordre) + ''" class="min-w-8 cursor-move" />
            @if (photo.ordre == 0) {
              <p-tag icon="pi pi-fw pi-image" value="Couverture" severity="contrast" class="select-none" />
            }
            <p-button (click)="deletePhoto(photo)" icon="pi pi-trash" size="small" severity="danger"/>
          </div>
        </div>
      </div>
    }
    <div class="col-span-4">
      <button pButton [outlined]="true" class="w-full aspect-square" (click)="showPhotoModal()">
        <div class="flex flex-col items-center justify-center h-full py-2">
          <span class="pi pi-plus text-primary-500 mb-2 !text-2xl"></span>
          <span class="text-xl">Ajouter une photo</span>   
        </div>
      </button>
    </div>
  </div>
}